import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    tagline: 'She learns.',
    background: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/photo_2025-11-13_17-38-59.jpg"
  }, {
    tagline: 'She leads.',
    background: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/photo_2025-11-13_17-38-56.jpg"
  }, {
    tagline: 'She wins.',
    background: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/r4ghx198qvioniuadphfqh/81449d38-4222-488a-b12b-9f20b25eda97/she-wins1.jpg"
  }];
  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <section id="home" className="relative min-h-screen flex items-center justify-center pt-16 overflow-hidden" data-id="element-190">
      {/* Background Images with Fade Effect */}
      {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} style={{
      backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('${slide.background}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-191" />)}
      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-192">
        <div className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-193">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-194">
            She Wins International Ministry
          </h1>
          {/* Carousel Taglines */}
          <div className="relative h-20 mb-8" data-id="element-195">
            {slides.map((slide, index) => <p key={index} className={`absolute inset-0 text-3xl md:text-5xl font-bold text-pink-400 transition-all duration-1000 ${index === currentSlide ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-196">
                {slide.tagline}
              </p>)}
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-197">
            <a href="#programs" className="bg-pink-600 hover:bg-pink-700 text-white font-medium py-3 px-8 rounded-full transition-colors duration-200" data-id="element-198">
              Join Weekly Broadcast
            </a>
            <a href="#about" className="bg-transparent hover:bg-white/10 text-white border border-white font-medium py-3 px-8 rounded-full transition-colors duration-200" data-id="element-199">
              Learn More
            </a>
          </div>
        </div>
      </div>
      {/* Carousel Navigation Arrows */}
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-colors duration-200" aria-label="Previous slide" data-id="element-200">
        <ChevronLeft size={24} data-id="element-201" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-colors duration-200" aria-label="Next slide" data-id="element-202">
        <ChevronRight size={24} data-id="element-203" />
      </button>
      {/* Carousel Dots */}
      <div className="absolute bottom-24 left-0 right-0 flex justify-center gap-2 z-20" data-id="element-204">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-pink-600 w-8' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-205" />)}
      </div>
      {/* Scroll Down Arrow */}
      <div className="absolute bottom-10 left-0 right-0 flex justify-center z-20" data-id="element-206">
        <a href="#about" className="text-white animate-bounce" aria-label="Scroll down" data-id="element-207">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-208">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-209" />
          </svg>
        </a>
      </div>
    </section>;
}